import axios from 'axios';

export default {
  getPlatforms({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/platform/get`,
        params: ctx,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertPlatforms', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addPlatform({ commit, state }, { platform, event }) {
    return new Promise((resolve, reject) => {
      commit('addPlatformRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/platform/add`,
        params: platform,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('addPlatformRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('addPlatformRequestError', err);
          reject(err);
        });
    });
  },
  editPlatform({ commit, state }, { platform, event }) {
    return new Promise((resolve, reject) => {
      commit('editPlatformRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/platform/edit`,
        params: platform,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('editPlatformRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('editPlatformRequestError', err);
          reject(err);
        });
    });
  },
  deletePlatform({ commit, state }, platformId) {
    return new Promise((resolve, reject) => {
      commit('deletePlatformRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/platform/destroy`,
        params: { id: platformId },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('deletePlatformRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('deletePlatformRequestError', err);
          reject(err);
        });
    });
  }
};
